export const QuoteFeedType = 10;
export const SpreadFeedType = 11;
export const OrderUpdateFeedType = 13;
export const BarUpdateFeedType = 14;
export var SpreadType;
(function (SpreadType) {
    SpreadType[SpreadType["Custom"] = 0] = "Custom";
    SpreadType[SpreadType["Vertical"] = 2] = "Vertical";
    SpreadType[SpreadType["Calendar"] = 3] = "Calendar";
    SpreadType[SpreadType["Butterfly"] = 4] = "Butterfly";
    SpreadType[SpreadType["Condor"] = 5] = "Condor";
    SpreadType[SpreadType["CoveredCall"] = 6] = "CoveredCall";
    SpreadType[SpreadType["IronCondor"] = 7] = "IronCondor";
    SpreadType[SpreadType["IronButterfly"] = 8] = "IronButterfly";
    SpreadType[SpreadType["Straddle"] = 9] = "Straddle";
    SpreadType[SpreadType["Strangle"] = 10] = "Strangle";
    SpreadType[SpreadType["MarriedPut"] = 11] = "MarriedPut";
    SpreadType[SpreadType["CoveredPut"] = 12] = "CoveredPut";
    SpreadType[SpreadType["MarriedCall"] = 13] = "MarriedCall";
    SpreadType[SpreadType["Collar"] = 14] = "Collar";
    SpreadType[SpreadType["Conversion"] = 15] = "Conversion";
})(SpreadType || (SpreadType = {}));
//# sourceMappingURL=Streaming.js.map